var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanksy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 133,
    viewBox: "0 0 85 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6377 103.718H19.768V130.843H25.6377V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5874 103.46L11.8069 102.451L7.05029 129.874L12.92 130.843L17.5874 103.46Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5074 103.718H25.6377V130.843H31.5074V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3772 103.718H31.5074V130.843H37.3772V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2469 103.718H37.3772V130.843H43.2469V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1166 103.718H43.2469V130.843H49.1166V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9863 103.718H49.1166V130.843H54.9863V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5021 101.604L54.9863 103.592L64.7692 130.843L70.6389 128.905L60.5021 101.604Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2633 98.8743L63.0248 101.496L77.5851 130.542L82.9141 127.875L68.2633 98.8743Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M80.299 2H2.03613V103.718H80.299V2Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4727 9.74994H9.86243V95.968H72.4727V9.74994Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4727 52.3746H9.86243V95.968H72.4727V52.3746Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1454 62.73C57.6849 61.319 54.3237 62.2302 52.8875 64.6476C52.2749 65.6738 51.9198 67.0447 51.9198 68.0035C51.9198 67.0447 51.5346 65.6935 50.9521 64.6476C49.5761 62.2006 46.1748 61.3782 43.6941 62.73C41.2034 64.0818 40.5458 67.815 41.7587 70.4005C43.6941 74.5267 51.9198 80.4682 51.9198 80.4682C51.9198 80.4682 60.929 73.5679 62.0809 70.4005C63.3483 67.815 62.606 64.141 60.1454 62.73Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanksy);
export default __webpack_public_path__ + "static/media/Banksy.139318b7.svg";
export { ForwardRef as ReactComponent };var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanksy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 133,
    viewBox: "0 0 85 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6377 103.718H19.768V130.843H25.6377V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5874 103.46L11.8069 102.451L7.05029 129.874L12.92 130.843L17.5874 103.46Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5074 103.718H25.6377V130.843H31.5074V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3772 103.718H31.5074V130.843H37.3772V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2469 103.718H37.3772V130.843H43.2469V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1166 103.718H43.2469V130.843H49.1166V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9863 103.718H49.1166V130.843H54.9863V103.718Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5021 101.604L54.9863 103.592L64.7692 130.843L70.6389 128.905L60.5021 101.604Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2633 98.8743L63.0248 101.496L77.5851 130.542L82.9141 127.875L68.2633 98.8743Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M80.299 2H2.03613V103.718H80.299V2Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4727 9.74994H9.86243V95.968H72.4727V9.74994Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4727 52.3746H9.86243V95.968H72.4727V52.3746Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1454 62.73C57.6849 61.319 54.3237 62.2302 52.8875 64.6476C52.2749 65.6738 51.9198 67.0447 51.9198 68.0035C51.9198 67.0447 51.5346 65.6935 50.9521 64.6476C49.5761 62.2006 46.1748 61.3782 43.6941 62.73C41.2034 64.0818 40.5458 67.815 41.7587 70.4005C43.6941 74.5267 51.9198 80.4682 51.9198 80.4682C51.9198 80.4682 60.929 73.5679 62.0809 70.4005C63.3483 67.815 62.606 64.141 60.1454 62.73Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanksy);
export default __webpack_public_path__ + "static/media/Banksy.139318b7.svg";
export { ForwardRef as ReactComponent };